<template>
  <div class="hero">
    <div class="content">
      <div class="logo">
        <img src="../assets/logo.svg" alt>
      </div>
      <div class="about">
        <h1 class="sitename">Clint Robinson</h1>
        <h2>A Front-end developer from Edmonton, Alberta</h2>
      </div>
    </div>
    <div class="video-container">
      <video autoplay loop muted playsinline class="fillWidth">
        <source src="../assets/video/City-Nights.mp4" type="video/mp4">Your browser does not support the video tag. I suggest you upgrade your browser.
        <source src="../assets/video/City-Nights.webm" type="video/webm">Your browser does not support the video tag. I suggest you upgrade your browser.
      </video>
      <div class="about-me">
        <p>I am a Front End Developer with over a decade of experience designing and building websites/web applications using modern web technology. I have received industry recognition by way of the Digital Alberta Awards and the Webby's for my work on the Tourism Jasper and Make Something Edmonton websites respectively.</p>
        <div class="built-with">Site Built With</div>
        <ul class="technology">
          <li>
            <i class="fab fa-vuejs"></i>
          </li>
          <li>
            <i class="fab fa-sass"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "Hero",
    props: {
        msg: String
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.hero {
    background: #012042;
    width: 100%;
    position: relative;
    overflow: hidden;
    min-height: 800px;
}

.grid {
    z-index: 2;
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 4rem 1rem;
    top: 0;
    flex-direction: column;
}

.content {
    height: 80vh;
    min-height: 800px;
    position: relative;
    overflow: hidden;

    &:before {
        content: "";
        position: absolute;
        display: block;
        height: 100%;
        z-index: 2;
        background-color: rgba(orangered, 0.85);
        min-height: 90vh;
        width: 67rem;
        animation-delay: 10ms;
        transform: skew(-45deg) translate3d(-2.5rem, 0, 0);
        transform-origin: top;
    }
    @media only screen and (min-width: 768px) {
        &:before {
            min-height: 90vh;
            width: 47rem;
        }
    }

    @media only screen and (min-width: 1200px) {
        &:before {
            min-height: 90vh;
            width: 67rem;
        }
    }
}

.logo {
    position: absolute;
    z-index: 2;
    top: 3rem;
    left: 3rem;
    display: none;

    @media only screen and (min-width: 768px) {
        display: block;
        width: 200px;
    }

    @media only screen and (min-width: 1200px) {
        width: 300px;
    }
}

.about {
    position: absolute;
    text-align: center;
    z-index: 20;
    padding: 0 1rem 1rem;
    margin-top: 1.5rem;
    width: 100%;

    @media only screen and (min-width: 768px) {
        padding: 0 2rem 1rem 2rem;
        top: 240px;
        left: -40px;
        transform: rotate(-45deg);
        text-align: left;
        width: auto;
        margin-top: 0;

        //border-top: 2px solid white;
        //border-bottom: 2px solid white;

        &:before {
            content: "";
            background: white;
            height: 2px;
            //width: 100%;
            position: absolute;
            right: 1rem;
            left: 2rem;
        }
        &:after {
            content: "";
            background: white;
            height: 2px;
            //width: 100%;
            position: absolute;
            right: 2.25rem;
            left: 0.75rem;
        }
    }

    @media only screen and (min-width: 1200px) {
        padding: 0 2rem 1rem 2rem;
        top: 340px;
        left: -20px;
        transform: rotate(-45deg);
        text-align: left;
        width: auto;
        margin-top: 0;

        //border-top: 2px solid white;
        //border-bottom: 2px solid white;

        //position: relative;

        &:before {
            content: "";
            background: white;
            height: 2px;
            //width: 100%;
            position: absolute;
            right: 0.5rem;
            left: 2rem;
        }
        &:after {
            content: "";
            background: white;
            height: 2px;
            //width: 100%;
            position: absolute;
            right: 1.75rem;
            left: 0.75rem;
        }
    }
}
.sitename {
    color: white;
    font-size: 2rem;
    margin-bottom: 1rem;
    margin-top: 0;
    text-transform: uppercase;
    font-family: magion-web, sans-serif;
    font-weight: 400;
    line-height: 1;
    font-style: italic;
    position: relative;
    z-index: 10;

    @media only screen and (min-width: 480px) {
        margin: 0;
        font-size: 4rem;
    }
    @media only screen and (min-width: 768px) {
        font-size: 5rem;
    }
    @media only screen and (min-width: 1200px) {
        font-size: 6.8rem;
    }
}

h2 {
    color: white;
    text-transform: uppercase;
    margin: 0 0 0.5rem;
    letter-spacing: 0.14em;
    font-size: 0.5rem;

    @media only screen and (min-width: 768px) {
        font-size: 1.075rem;
    }
    @media only screen and (min-width: 1200px) {
        font-size: 1.5rem;
    }
}

.video-container {
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    width: 100%;

    &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(#012042, 0.75);

        bottom: 0;
        right: 0;
        z-index: 1;
    }
}

.about-me {
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 6rem;
    z-index: 100;
    color: white;
    width: auto;
    padding: 2rem;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 5px;

    @media only screen and (min-width: 768px) {
        top: auto;
        bottom: 3rem;
        left: 2rem;
        right: 2rem;

        position: absolute;
        left: auto;
        width: 50%;
        padding: 2rem 3rem;
    }

    .built-with {
        font-size: 0.75rem;
        text-transform: uppercase;
        color: #ddd;
        margin-bottom: 0.5rem;
    }

    .technology {
        padding: 0 0 1rem;
        margin: 0 0 1rem;
        list-style: none;
        border-bottom: 1px solid orangered;

        li {
            display: inline;
            padding-right: 1rem;
        }
    }

    h3 {
        font-size: 3rem;
        margin: 0;
    }
    p {
        margin: 0 0 1rem;
        font-size: 1.25rem;

        @media only screen and (min-width: 768px) {
            font-size: 1rem;
        }

        @media only screen and (min-width: 1200px) {
            font-size: 1.25rem;
        }
    }

    i {
        font-size: 2rem;
    }

    .btn {
        color: white;
        font-size: 1.5rem;
        text-decoration: none;
    }
}
</style>
